<p-button
  [rounded]="true"
  [text]="true"
  size="small"
  severity="secondary"
  (onClick)="onClick($event)"
  [disabled]="disabled()"
>
  @if (label()) {
    <p class="font-medium" [ngClass]="textColor()">{{ label() }}</p>
  }
  <span
    class="material-symbols-outlined"
    [ngClass]="textColor()"
    [ngStyle]="{ 'font-size': sizePx() }"
  >
    {{ icon() }}
  </span>
</p-button>
